module.exports = __webpack_public_path__ + "static/banner-servicios-f39d4cea372fa9edffbd95b9081e4af4.jpg";